/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Autopsy} from '../../../_models/autopsy';

@Component({
  selector: 'app-dialog-confirm-autopsy',
  templateUrl: './dialog-confirm-autopsy.component.html',
  styleUrls: ['./dialog-confirm-autopsy.component.scss']
})
export class DialogConfirmAutopsyComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public dialogRef: MatDialogRef<DialogConfirmAutopsyComponent>, @Inject(MAT_DIALOG_DATA) public autopsy: Autopsy) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUE GETTERS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get isGRO(): boolean {
    return this.autopsy && this.autopsy.code === 'GRO';
  }

  get isSTD(): boolean {
    return this.autopsy && this.autopsy.code === 'STD';
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              CLICK LISTENERS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(res: boolean): void {
    this.dialogRef.close(res);
  }

}
